/** Shared, strict form conversion for document metadata. Empty values mean removal. */
export const parseDocumentAmount = (value: unknown): number | null => {
  if (value === null || value === undefined || String(value).trim() === '') return null;
  if (typeof value === 'number') return Number.isFinite(value) && Number(value.toFixed(2)) === value ? value : null;
  const raw = String(value).trim();
  let normalized: string;
  if (/^-?\d+(?:,\d{1,2})?$/.test(raw)) normalized = raw.replace(',', '.');
  else if (/^-?\d{1,3}(?:\.\d{3})+(?:,\d{1,2})?$/.test(raw)) normalized = raw.replace(/\./g, '').replace(',', '.');
  else if (/^-?\d+\.\d{1,2}$/.test(raw)) normalized = raw;
  else return null;
  const amount = Number(normalized);
  return Number.isFinite(amount) ? Math.round(amount * 100) / 100 : null;
};

/** Calendar date, without parsing date-only strings through UTC/local time zones. */
export const documentDateToIso = (value: unknown): string | null => {
  const raw = String(value ?? '').trim();
  if (!raw) return null;
  let year: number, month: number, day: number;
  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:\d{2})?)?$/);
  const de = raw.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (iso) [, year, month, day] = iso.map(Number);
  else if (de) [, day, month, year] = de.map(Number);
  else return null;
  if (year < 1000 || year > 9999 || month < 1 || month > 12 || day < 1) return null;
  const days = new Date(year, month, 0).getDate();
  if (day > days) return null;
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

export const formatDocumentAmount = (value: unknown): string => {
  const amount = parseDocumentAmount(value);
  return amount === null ? '' : amount.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatDocumentDate = (value: unknown): string => {
  const iso = documentDateToIso(value);
  return iso ? `${iso.slice(8, 10)}.${iso.slice(5, 7)}.${iso.slice(0, 4)}` : String(value ?? '');
};

export const localTodayIso = (): string => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
};
